export interface MainButtonProps {
  label: string;
  onClick: Function;
  isDark?: boolean;
  className?: string;
}

const MainButton: React.FC<MainButtonProps> = ({
  label,
  onClick,
  isDark = true,
  className,
}) => {
  return (
    <>
      <button
        type="button"
        onClick={(e) => {
          onClick(e);
        }}
        className={`m-1 rounded-lg border border-transparent ${
          !isDark
            ? "border-gray-500 focus:ring-blue-500 text-blue-600 bg-white hover:bg-blue-100"
            : "focus:ring-blue-500 bg-blue-600 hover:bg-blue-700 text-white"
        }   text-base   shadow-sm  focus:outline-none focus:ring-2  focus:ring-offset-2 text-tootler-dark-grey ${className}`}
      >
        {label}
      </button>
    </>
  );
};

export default MainButton;
